import { FC } from "react";

import { Box, chakra } from "@chakra-ui/react";
import { i18n, Trans, useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Message from "@components/Message";
import responsiveStyle from "@lib/theme/responsiveStyle";

const SuccessMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Message
        variant="success"
        icon={<Icon icon="success" size="2.25rem" />}
        padding={responsiveStyle({ mobile: "1rem 1rem", desktop: "1.75rem 1.25rem" })}
      >
        <Box fontSize={responsiveStyle({ mobile: "1.125rem", desktop: "1.5rem" })}>
          <Trans
            i18n={i18n!}
            i18nKey="order-success-parcel_prepared"
            components={{
              here: (
                <chakra.a
                  href={t("order-success-parcel_prepared_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
            }}
          />
        </Box>
      </Message>
    </Box>
  );
};
export default SuccessMessage;
